import React, { useState, useEffect } from 'react'
import { toast } from 'react-toastify'
import { Button } from 'reactstrap'

export default function SubscribeForm({ status, message, onValidated }) {
    let [state, setState] = useState({
        email: '',
        loading: false
    })
    const handleSubmit = (e) => {
        e.preventDefault();
        state.email &&
            state.email.indexOf("@") > -1 &&
            onValidated({
                EMAIL: state.email
            });
        setState((prev) => ({
            ...prev,
            loading: true
        }))
    }

    useEffect(() => {
        if (status === "success") {
            toast.success(message || "Successful")
            setState((prev) => ({
                ...prev,
                email: '',
                loading: false
            }))
        } else if (message) {
            toast.error(message)
            setState((prev)=>({
                ...prev,
                loading: false
            }))
        }
    }, [status, message])
    return (
        <form onSubmit={handleSubmit} className="d-md-flex d-block footer_form ">
            <div className="d-flex mr-3 mb-3 w-100 footer-input align-items-center">
                <input onChange={(e) => setState((prevState) => ({ ...prevState, email: e.target.value }))} value={state.email} className="w-100" type="email" required={true} placeholder="Enter your email" name="email" id="mce-email"></input>
            </div>
            <Button color="white" block>{state.loading ? "loading..." : "Subscribe"}</Button>
        </form>
    )
}
